// extracted by mini-css-extract-plugin
export default {"title":"TransportScreen_title__1o-Fa","mainDiv":"TransportScreen_mainDiv__Yb1s2"};